import notificationError from '@/utils/functions/notificationError';
import { notification } from 'antd';
import { useMutation } from 'react-query';
import { getQuestReportCsvCommisionByMovement } from './CommissionByMoviment.service';

export function useCommisionByMovementCsv() {
  return useMutation(getQuestReportCsvCommisionByMovement, {
    onSuccess() {
      notification.success({
        message:
          'O relatório Commissão por Movimentação foi gerado com sucesso!',
      });
    },

    onError(error) {
      notificationError(error);
    },
  });
}
